import { render, staticRenderFns } from "./TvaVideoPlayer.vue?vue&type=template&id=bd2ba700&scoped=true&"
import script from "./TvaVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./TvaVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TvaVideoPlayer.vue?vue&type=style&index=0&id=bd2ba700&lang=scss&scoped=true&"
import style1 from "./TvaVideoPlayer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2ba700",
  null
  
)

export default component.exports